import { z } from 'zod';

import { WriteoffId } from '../BrandedIds';
import { BaseUpsertTransactionSideEffect } from './BaseUpsertTransactionSideEffect';

export const UpsertWriteoffSideEffectContext = BaseUpsertTransactionSideEffect.extend({
  writeoffId: WriteoffId,
});
export const UpsertWriteoffSideEffect = UpsertWriteoffSideEffectContext.extend({
  type: z.literal('upsertWriteoff'),
});
export type UpsertWriteoffSideEffect = z.infer<typeof UpsertWriteoffSideEffect>;
